import { selectConfig } from 'domains/config/selectors'
import { useSelector } from 'react-redux'

export const useConfig = () => useSelector(selectConfig)

export function useParticipants() {
  const { agentParticipant, userParticipant } = useConfig()

  return {
    agent: agentParticipant,
    user: userParticipant,
  }
}

export function useStartChatIcon() {
  const { startChatIcon } = useConfig()

  return startChatIcon
}
